import { ALERT_UPDATE_COMPOSE_DATA } from "./types";

import { toggleWarning } from "./alerts-api";

import { StepperStates } from "../../components";

import { GOOGLE_API_KEY } from "../../App/globals";

import { appendToList, removeFromList } from "./alerts-list-api";

import * as moment from "moment";

export const updateStepper = (ref: any) => {
  const { dispatch, composeData, nav, init, history } = ref;
  const { stepper } = composeData;
  const { data } = stepper;
  const finished = stepper.finished;
  let found = false;
  let step = 0;

  for (let i = 0; i < data.length; i++) {
    if (nav.includes(data[i].nav)) {
      step = i;
    }
  }
  if (step - finished <= 1 || init) {
    composeData.loading = true;
    updateComposeData({
      dispatch,
      newComposeData: JSON.parse(JSON.stringify(composeData))
    });

    setTimeout(() => {
      if (!init) {
        history.push("/alerts/compose/" + nav);
      }
      for (let i = 0; i < data.length; i++) {
        data[i].state = StepperStates.finished;
        if (i === step) {
          data[i].state = StepperStates.active;
          found = true;
        } else if (found) {
          data[i].state = StepperStates.default;
        }
      }

      composeData.stepper.data = data;
      composeData.stepper.step = step;

      if (step > finished) {
        composeData.stepper.finished = step;
      }

      resetRecordState({ composeData, dispatch });

      composeData.loading = false;
      const newComposeData = JSON.parse(JSON.stringify(composeData));
      updateComposeData({ dispatch, newComposeData });
    }, 1000);
  }
};

export const launchCodeChanged = (ref: any) => {
  const { dispatch, id, value, composeData } = ref;
  composeData.previewSend[id] = value;
  updateComposeData({
    dispatch,
    newComposeData: JSON.parse(JSON.stringify(composeData))
  });
};

export const retryCompose = (ref: any) => {
  const { dispatch, composeData } = ref;
  composeData.previewSend.launch1 = "";
  composeData.previewSend.launch2 = "";
  composeData.previewSend.launch3 = "";
  composeData.previewSend.launch4 = "";
  updateComposeData({
    dispatch,
    newComposeData: JSON.parse(JSON.stringify(composeData))
  });
};

export const sendCompose = (ref: any) => {
  const { dispatch, composeData } = ref;
  composeData.loading = true;
  updateComposeData({
    dispatch,
    newComposeData: JSON.parse(JSON.stringify(composeData))
  });
  setTimeout(() => {
    composeData.previewSend.launch1 = "";
    composeData.previewSend.launch2 = "";
    composeData.previewSend.launch3 = "";
    composeData.previewSend.launch4 = "";
    composeData.loading = false;
    updateComposeData({
      dispatch,
      newComposeData: JSON.parse(JSON.stringify(composeData))
    });
  }, 1000);
};

export const scheduleAlert = (ref: any) => {
  const { scheduledDate, data, scheduledTime } = ref;
  const dateStr = scheduledDate + "/" + scheduledTime;
  let date: any = moment(dateStr, "MM/DD/YY/hh:mma").toDate();
  date = Math.floor(date.getTime() / 1000);
  data.date = date;

  const messageDetails = data.composeMessage.messageDetails;
  const geoFence = data.chooseAudience.geoFence;
  const alertDetails = data.alertDetails;
  const incidentLocation = alertDetails.incidentLocation;
  const severity = alertDetails.severity;
  const iPawsDetails = alertDetails.iPawsDetails;

  data.description = messageDetails.description.value;
  data.title = messageDetails.headline.value;
  data.instructions = messageDetails.instructions.value;
  data.type = severity.type;
  data.mapCenter = geoFence.center || incidentLocation.center;
  data.currentShape = geoFence.currentShape;

  let expiration = alertDetails.expiration.value;

  if (expiration === "custom") {
    expiration =
      alertDetails.expiration.custom.days +
      " days" +
      alertDetails.expiration.custom.hours +
      " hours" +
      alertDetails.expiration.custom.minutes +
      " minutes";
  }

  const analytics = {
    reach: "1000",
    views: "400",
    replies: "11"
  };

  const details = {
    sentOn: scheduledDate,
    expires: expiration,
    severity: severity.type,
    urgency: iPawsDetails.urgency.value,
    certainty: iPawsDetails.certainty.value,
    sentBy: alertDetails.senderName.value,
    area: "string",
    agency: "string",
    alertType: iPawsDetails.category.value,
    status: "string",
    anotherItem: "string",
    bigItem: "string"
  };

  data.analytics = analytics;
  data.details = details;
  ref.data = JSON.parse(JSON.stringify(data));
  appendToList(ref);
};

export const previewSendToggleLaunch = (ref: any) => {
  const { dispatch, composeData } = ref;
  composeData.previewSend.launchActive = !composeData.previewSend.launchActive;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const selectChannelsBoxListChanged = (ref: any) => {
  const { dispatch, composeData, id, type } = ref;
  const { selectChannels } = composeData;
  const box = selectChannels[id];
  const list = box.list;
  const itemKey = list[type];
  const item = itemKey[Object.keys(itemKey)[0]];
  item.status = !item.status;

  let counter = 0;

  for (const key of Object.keys(list)) {
    const tempItemKey = list[key];
    const tempItem = tempItemKey[Object.keys(tempItemKey)[0]];
    if (tempItem.status) {
      counter++;
    }
  }

  if (counter === 0) {
    selectChannelsBoxClicked({ dispatch, id, composeData, setStatus: false });
  }

  composeData.selectChannels = selectChannels;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const selectChannelsBoxClicked = (ref: any) => {
  const { dispatch, composeData, id, setStatus } = ref;
  const { selectChannels } = composeData;

  if (setStatus === undefined) {
    if (selectChannels[id].list === undefined) {
      selectChannels[id].status = !selectChannels[id].status;
    } else if (!selectChannels[id].status) {
      selectChannels[id].status = true;
      selectChannelsBoxListChanged({ dispatch, composeData, id, type: 0 });
    }
  } else {
    selectChannels[id].status = setStatus;
  }

  composeData.selectChannels = selectChannels;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const manageGroupList = (ref: any) => {
  const { dispatch, composeData, type } = ref;
  const formattedType = type.toLowerCase();
  const groups = composeData.chooseAudience.audiences.groups;
  const list = groups.list;
  if (formattedType === "all") {
    for (const key of Object.keys(list)) {
      list[key].active = true;
    }
    groups.selected = list.length;
  } else if (formattedType === "none") {
    for (const key of Object.keys(list)) {
      list[key].active = false;
    }
    groups.selected = 0;
  }
  composeData.chooseAudience.audiences.groups = groups;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const composeAction = (ref: any) => {
  const { dispatch } = ref;
  let { value } = ref;
  let warningContent;
  let callback;

  value = value.toLowerCase();

  if (value.includes("save")) {
    warningContent = {
      header: "Save this alert?",
      body: "Are you sure you want to save this alert?"
    };
    callback = () => {
      appendToList(ref);
    };
  } else if (value.includes("delete")) {
    warningContent = {
      header: "Delete this alert?",
      body: "Are you sure you want to delete this alert?"
    };
    callback = () => {
      removeFromList(ref);
    };
  }

  toggleWarning({ dispatch, warningContent, setWarningActive: true, callback });
};

export const audienceListCheckBoxChanged = (ref: any) => {
  const { dispatch, id, composeData } = ref;
  const groups = composeData.chooseAudience.audiences.groups;
  const list = groups.list;

  for (const key of Object.keys(list)) {
    if (key === id) {
      const checked = list[key].checked;
      if (checked) {
        list[key].checked = false;
        groups.selected = groups.selected > 0 ? groups.selected - 1 : 0;
      } else {
        list[key].checked = true;
        groups.selected++;
      }
      break;
    }
  }

  composeData.chooseAudience.audiences.groups = groups;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const chooseAudienceBoxClicked = (ref: any) => {
  const { dispatch, id, composeData, history } = ref;
  if (id === "everyone") {
    updateAudienceEveryone({ dispatch, composeData });
  } else if (id === "group" || id === "geofence") {
    const pathname = history.location.pathname;
    history.push(pathname + "/" + id);
    const newComposeData = JSON.parse(JSON.stringify(composeData));
    updateComposeData({ dispatch, newComposeData });
  }
};

const updateAudienceEveryone = (ref: any) => {
  const { dispatch, composeData } = ref;
  const audiences = deSelectAudiences(composeData.chooseAudience.audiences);
  audiences.everyone.status = true;
  composeData.chooseAudience.audiences = audiences;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const showComposeToolBars = (ref: any) => {
  const { dispatch, composeData } = ref;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const saveAudienceGroups = (ref: any) => {
  const { dispatch, history, composeData, list } = ref;
  let groups = composeData.chooseAudience.audiences.groups;
  const audiences = deSelectAudiences(composeData.chooseAudience.audiences);
  groups = audiences.groups;
  groups.status = true;
  groups.list = list;
  console.log(groups, 'groups');
  const tagList = getTagList({groups});
  groups.groupTagList = tagList;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
  history.replace("/alerts/compose");
}

const getTagList = (ref: any) => {
  const { groups } = ref;
  const list = groups.list;
  const tagList = [];
  for (const key of Object.keys(list)) {
    if (list[key].checked) {
      tagList.push(list[key]);
    }
  }
  return tagList;
};

export const cancelAudienceGroups = (ref: any) => {
  const { history } = ref;
  history.replace("/alerts/compose");
}

export const copyData = (ref: any) => {
  const { dispatch, id, composeData } = ref;
  composeData.copiedData = composeData[id];
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

const deSelectAudiences = (list: any) => {
  for (const key of Object.keys(list)) {
    list[key].status = false;
  }
  return list;
};

const updateComposeData = (ref: any) => {
  const { dispatch, newComposeData } = ref;
  dispatch({
    type: ALERT_UPDATE_COMPOSE_DATA,
    payload: newComposeData
  });
};

export const alertDetailsUpdateSeverity = (ref: any) => {
  const { dispatch, composeData, type, id } = ref;
  const { alertDetails } = composeData;
  const { severity } = alertDetails;
  severity.id = id;
  severity.type = type;
  composeData.alertDetails.severity = severity;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const alertDetailsBoxClicked = (ref: any) => {
  const { history, id, composeData, dispatch } = ref;
  const pathname = history.location.pathname;
  history.push(pathname + "/" + id);
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const clearMap = (ref: any) => {
  const { dispatch, composeData, id } = ref;
  if (id === "alertDetails") {
    composeData[id].incidentLocation.status = false;
    composeData[id].incidentLocation.marker = null;
  } else if (id === "chooseAudience") {
    composeData[id].geoFence.status = false;
    composeData[id].geoFence.currentShape = null;
  }
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const alertDetailsToggleInfo = (ref: any) => {
  const { dispatch, composeData, type } = ref;
  const moreInfo = !composeData.alertDetails[type].moreInfo;
  composeData.alertDetails[type].moreInfo = moreInfo;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const alertDetailsMarkerComplete = (ref: any) => {
  const { dispatch, composeData, marker } = ref;
  composeData.alertDetails.incidentLocation.marker = marker;
  if (marker !== null) {
    composeData.alertDetails.incidentLocation.center = marker.center;
    let center = JSON.parse(JSON.stringify(marker.center));
    center = center.lat + "," + center.lng;
    const smallSize = "277x120";
    const mediumSize = "324x207";
    const largeSize = "840x173";
    marker.small = `https://maps.googleapis.com/maps/api/staticmap?&size=${smallSize}&markers=${center}&key=${GOOGLE_API_KEY}`;
    marker.medium = `https://maps.googleapis.com/maps/api/staticmap?&size=${mediumSize}&markers=${center}&key=${GOOGLE_API_KEY}`;
    marker.large = `https://maps.googleapis.com/maps/api/staticmap?&size=${largeSize}&markers=size:mid|color:0x1f76ff|${center}&key=${GOOGLE_API_KEY}`;
  }
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const alertDetailsUpdateIncidentLocation = (ref: any) => {
  const { dispatch, composeData, status, history, path } = ref;
  const marker = composeData.alertDetails.incidentLocation.marker;

  if (!status && marker === null) {
    composeData.alertDetails.incidentLocation.status = false;
  } else if (status && marker) {
    composeData.alertDetails.incidentLocation.status = true;
  }
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
  history.replace(path);
};

export const alertDetailsUpdateIPaws = (ref: any) => {
  const { dispatch, composeData, type, value } = ref;
  composeData.alertDetails.iPawsDetails[type].value = value;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const alertDetailsUpdateRadio = (ref: any) => {
  const { dispatch, composeData, type, value } = ref;
  composeData.alertDetails[type].value = value;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const alertDetailsUpdateInput = (ref: any) => {
  const { dispatch, composeData, type, value } = ref;
  composeData.alertDetails[type].value = value;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const alertDetailsUpdateDetails = (ref: any) => {
  const { dispatch, composeData, type, value } = ref;
  if (type === "callerId") {
    composeData.alertDetails.voice.callerId.value = value;
  } else if (type === "callerName") {
    composeData.alertDetails.voice.callerName.value = value;
  } else if (type === "days") {
    composeData.alertDetails.expiration.custom.days = value;
  } else if (type === "hours") {
    composeData.alertDetails.expiration.custom.hours = value;
  } else if (type === "minutes") {
    composeData.alertDetails.expiration.custom.minutes = value;
  }
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const composeMessageToggleInfo = (ref: any) => {
  const { dispatch, composeData, type } = ref;
  const moreInfo = !composeData.composeMessage[type].moreInfo;
  composeData.composeMessage[type].moreInfo = moreInfo;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const composeMessageUpdateInput = (ref: any) => {
  const { dispatch, composeData, type, value } = ref;
  composeData.composeMessage.messageDetails[type].value = value;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const composeMessageMultiMediaClicked = (ref: any) => {
  const { dispatch, composeData, type, state } = ref;
  const multiMedia = composeData.composeMessage.multiMedia;
  composeData.composeMessage.multiMedia = multiMedia;
  if (type) {
    multiMedia.fileTypes = type;
  } else {
    multiMedia.fileName = null;
    multiMedia.fileTypes = null;
  }

  composeMessageUpdateMultiMediaState({ dispatch, composeData, state });
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const composeMessageUpdateMultiMediaState = (ref: any) => {
  const { dispatch, composeData, state } = ref;
  composeData.composeMessage.multiMedia.state = state;
  if (state === "init") {
    resetRecordState(ref);
  }
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

const resetRecordState = (ref: any) => {
  const { dispatch, composeData } = ref;
  audio = null;
  mediaRecorder = null;
  if (stream) {
    stream.getTracks().forEach((track: any) => track.stop());
  }
  stream = null;
  audioFile = null;
  composeData.composeMessage.multiMedia.voice.state = null;
  composeData.composeMessage.multiMedia.voice.timer = null;
  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

export const composeMessageUploadMultiMedia = (ref: any) => {
  const { dispatch, composeData, files, id } = ref;
  const { multiMedia } = composeData.composeMessage;

  const reader = new FileReader();
  let counter = 0;
  multiMedia.fileName = files[counter].name;
  reader.readAsDataURL(files[counter]);

  reader.onloadend = () => {
    const result = reader.result;
    multiMedia.files.push({
      name: files[counter].name,
      data: files[counter],
      src: result,
      size: Math.round(files[counter].size / 10000) / 100,
      type: files[counter].type,
      id
    });
    counter++;

    if (counter < files.length) {
      multiMedia.fileName = files[counter].name;
      reader.readAsDataURL(files[counter]);
    } else {
      multiMedia.uploadPercentage = null;
      multiMedia.fileName = null;
    }
    updateComposeData({
      dispatch,
      newComposeData: JSON.parse(JSON.stringify(composeData))
    });
  };

  reader.onprogress = evt => {
    let uploadPercentage = 0;
    uploadPercentage = Math.round(evt.loaded / evt.total * 100);
    multiMedia.uploadPercentage = uploadPercentage;
    updateComposeData({
      dispatch,
      newComposeData: JSON.parse(JSON.stringify(composeData))
    });
  };
};

export const composeMessageRemoveMultiMedia = (ref: any) => {
  const { dispatch, composeData, name } = ref;
  const files = composeData.composeMessage.multiMedia.files;

  const index = files
    .map((e: any) => {
      return e.name;
    })
    .indexOf(name);

  if (index > -1) {
    files.splice(index, 1);
  }

  composeData.composeMessage.multiMedia.files = files;

  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
};

declare let MediaRecorder: any;
let audio: any;
let mediaRecorder: any;
let audioFile: any;
let stream: any;

const initializeMediaRecorder = (ref: any) => {
  return new Promise((res, rej) => {
    const constraints = {
      audio: true
    };
    let chunks: any = [];
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(s => {
        stream = s;
        audio = new Audio();
        mediaRecorder = new MediaRecorder(stream);
        res(mediaRecorder);

        mediaRecorder.onstop = (e: any) => {
          audio.controls = true;
          const blob = new Blob(chunks, { type: "audio/ogg; codecs=opus" });
          chunks = [];
          const audioURL = URL.createObjectURL(blob);
          audio.src = audioURL;
          audioFile = {
            name: "audio-recording" + ".mp3",
            size: blob.size,
            id: "audio",
            data: blob,
            type: "mp3"
          };
        };

        mediaRecorder.ondataavailable = (e: any) => {
          chunks.push(e.data);
        };

        return mediaRecorder;
      })
      .catch(err => {
        // console.log(err);
      });
  });
};

let totalSeconds = 0;
let maxTime: any = null;
let timerInterval: any;

export const composeMessageRecordAudio = (ref: any) => {
  const { composeData, dispatch, type } = ref;

  if (type === "init") {
    mediaRecorder = initializeMediaRecorder(ref).then(() => {
      composeData.composeMessage.multiMedia.voice.timer = "00:00";
      updateState();
    });
  } else if (type === "record") {
    updateState();
    totalSeconds = 0;
    maxTime = null;
    timerInterval = setInterval(setTimer, 1000, { dispatch, composeData });
    mediaRecorder.start();
  } else if (type === "stop") {
    if (timerInterval !== undefined) {
      clearInterval(timerInterval);
    }
    maxTime = totalSeconds;
    composeData.composeMessage.multiMedia.voice.timer = "00:00";
    totalSeconds = 0;
    updateState();
    mediaRecorder.stop();
  } else if (type === "play") {
    updateState();
    timerInterval = setInterval(setTimer, 1000, {
      dispatch,
      composeData
    });
    audio.play();
  } else if (type === "pause") {
    if (timerInterval !== undefined) {
      clearInterval(timerInterval);
    }
    if (maxTime === totalSeconds) {
      composeData.composeMessage.multiMedia.voice.timer = "00:00";
      totalSeconds = 0;
    }
    updateState();
    audio.pause();
  } else if (type === "delete") {
    mediaRecorder = initializeMediaRecorder(ref).then(() => {
      composeData.composeMessage.multiMedia.voice.timer = "00:00";
      updateState("init");
    });
  } else if (type === "save") {
    composeData.composeMessage.multiMedia.files.push(audioFile);
    composeData.composeMessage.multiMedia.voice.timer = "00:00";
    updateState("init");
  }

  function updateState(overWriteType?: string) {
    if (overWriteType) {
      composeData.composeMessage.multiMedia.voice.state = overWriteType;
    } else {
      composeData.composeMessage.multiMedia.voice.state = type;
    }
    updateComposeData({
      dispatch,
      newComposeData: JSON.parse(JSON.stringify(composeData))
    });
  }
};

const setTimer = (ref: any) => {
  const { composeData, dispatch } = ref;
  let seconds;
  let minutes;
  if (totalSeconds < maxTime || maxTime === null) {
    ++totalSeconds;
    seconds = pad(Math.floor(totalSeconds % 60));
    minutes = pad(Math.floor(totalSeconds / 60));

    composeData.composeMessage.multiMedia.voice.timer = minutes + ":" + seconds;
    updateComposeData({
      dispatch,
      newComposeData: JSON.parse(JSON.stringify(composeData))
    });
  }
  function pad(val: any) {
    const valString = val + "";
    if (valString.length < 2) {
      return "0" + valString;
    } else {
      return valString;
    }
  }
};

export const updateGeoFence = (ref: any) => {
  const { dispatch, status, composeData, history } = ref;
  const currentShape = composeData.chooseAudience.geoFence.currentShape;

  if (!status && composeData.copiedData && currentShape === null) {
    composeData.chooseAudience = composeData.copiedData;
    composeData.chooseAudience.geoFence.status = false;
    composeData.chooseAudience.geoFence.currentShape = null;
  } else if (status && currentShape) {
    composeData.chooseAudience.geoFence.status = true;
  }

  const newComposeData = JSON.parse(JSON.stringify(composeData));
  updateComposeData({ dispatch, newComposeData });
  history.replace("/alerts/compose");
};

export const chooseAudienceUpdateGeoMapList = (ref: any) => {
  const { dispatch, composeData, listItem } = ref;
  const list = composeData.chooseAudience.geoFence.list;
  const encodedPath = getEncodedPath({ shape: listItem });

  const size = "110x60";
  const smallSize = "277x120";
  const mediumSize = "324x207";
  const largeSize = "840x173";
  const pathStyle = "weight:4|fillcolor:0xa7a296|color:0x1f76ff";

  const mapStyle =
    "&style=feature:landscape|color:0xd4e7fd&style=feature:water|color:0xffffff&style=feature:administrative.country|element:labels|visibility:off&style=feature:road|element:geometry|color:white";
  listItem.src = `https://maps.googleapis.com/maps/api/staticmap?path=${pathStyle}|enc:${encodedPath}${mapStyle}&size=${size}&key=${GOOGLE_API_KEY}`;
  listItem.small = `https://maps.googleapis.com/maps/api/staticmap?path=${pathStyle}|enc:${encodedPath}&size=${smallSize}&key=${GOOGLE_API_KEY}`;
  listItem.medium = `https://maps.googleapis.com/maps/api/staticmap?path=${pathStyle}|enc:${encodedPath}&size=${mediumSize}&key=${GOOGLE_API_KEY}`;
  listItem.large = `https://maps.googleapis.com/maps/api/staticmap?path=${pathStyle}|enc:${encodedPath}&size=${largeSize}&key=${GOOGLE_API_KEY}`;
  list.push(listItem);
  updateComposeData({
    dispatch,
    newComposeData: JSON.parse(JSON.stringify(composeData))
  });
};

export const chooseAudienceUpdateGeoMapShape = (ref: any) => {
  const { dispatch, composeData, shape } = ref;

  if (shape.src === undefined) {
    const size = "110x60";
    const smallSize = "277x120";
    const mediumSize = "324x207";
    const largeSize = "840x173";
    const pathStyle = "weight:4|fillcolor:0xa7a296|color:0x1f76ff";
    const encodedPath = getEncodedPath({ shape });
    shape.src = `https://maps.googleapis.com/maps/api/staticmap?path=${pathStyle}|enc:${encodedPath}&size=${size}&key=${GOOGLE_API_KEY}`;
    shape.small = `https://maps.googleapis.com/maps/api/staticmap?path=${pathStyle}|enc:${encodedPath}&size=${smallSize}&key=${GOOGLE_API_KEY}`;
    shape.medium = `https://maps.googleapis.com/maps/api/staticmap?path=${pathStyle}|enc:${encodedPath}&size=${mediumSize}&key=${GOOGLE_API_KEY}`;
    shape.large = `https://maps.googleapis.com/maps/api/staticmap?path=${pathStyle}|enc:${encodedPath}&size=${largeSize}&key=${GOOGLE_API_KEY}`;
  }

  composeData.chooseAudience.geoFence.currentShape = shape;
  composeData.chooseAudience.geoFence.center = shape.center;

  updateComposeData({
    dispatch,
    newComposeData: JSON.parse(JSON.stringify(composeData))
  });
};

const getEncodedPath = (ref: any) => {
  const { shape } = ref;

  let encodedPath;

  if (shape.type === "rectangle") {
    const bounds = shape.bounds;
    let northEast = JSON.parse(JSON.stringify(bounds.getNorthEast()));
    let southWest = JSON.parse(JSON.stringify(bounds.getSouthWest()));
    const southEast = new google.maps.LatLng(northEast.lat, southWest.lng);
    const northWest = new google.maps.LatLng(southWest.lat, northEast.lng);
    northEast = new google.maps.LatLng(northEast.lat, northEast.lng);
    southWest = new google.maps.LatLng(southWest.lat, southWest.lng);
    const paths = new google.maps.MVCArray();
    paths.push(northWest);
    paths.push(northEast);
    paths.push(southEast);
    paths.push(southWest);
    paths.push(northWest);
    encodedPath = google.maps.geometry.encoding.encodePath(paths as any);
  } else if (shape.type === "polygon") {
    const paths = shape.paths;
    paths.push(paths[0]);
    encodedPath = google.maps.geometry.encoding.encodePath(paths);
  } else if (shape.type === "circle") {
    const radius = shape.radius;
    const center = shape.center;
    const paths = new google.maps.MVCArray();
    let d = 0;
    const points = 360;
    const p = 360 / points;
    for (let i = 0; i < points; ++i, d += p) {
      paths.push(
        google.maps.geometry.spherical.computeOffset(center, radius, d)
      );
    }
    encodedPath = google.maps.geometry.encoding.encodePath(paths as any);
  }

  return encodedPath;
};


// WEBPACK FOOTER //
// ./src/actions/alerts/alerts-compose-api.tsx